var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"affiliates-banner-footer"},[_c('div',{staticClass:"affiliates-banner-footer__container"},[_c('hot-banner',{attrs:{"title":_vm.title,"body":_vm.body,"buttons":_vm.buttons}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }